export function reuseHeaderIconInFooter() {
    const headerLogo = document.querySelector('#header-logo');
    const footerLogoContainer = document.querySelector('#footer-logo');

    if (!headerLogo || !footerLogoContainer) {
        return;
    }

    if (footerLogoContainer.querySelector('svg')) {
        return;
    }

    const cloned = headerLogo.cloneNode(true);
    cloned.setAttribute('aria-hidden', 'true');

    footerLogoContainer.innerHTML = '';
    footerLogoContainer.appendChild(cloned);
}
